<template>
  <Flex>
    <Flex>{{ $t('label.numberOfWords') }}</Flex>
    <DropDown
      :options="getSubOptions()"
      :selectedOptionIndex="selectedSubOptionIndex"
      @updateOption="onSubOptionUpdate"
    />
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import { isEqual } from 'lodash'
import DropDown from '@/components/DropDown'

export default {
  name: 'WordCloudNumberSelector',
  components: {
    Flex,
    DropDown,
  },
  props: {
    wordCloudColumns: Array,
  },
  data() {
    return {
      selectedSubOptionIndex: 0,
      selectedSubOption: this.getSubOptions()[0],
    }
  },
  mounted() {
    const foundSubOptionIndex = this.getSubOptions().findIndex(
      (subOption) => subOption.attributeValue === this.$route.query.limit,
    )
    this.selectedSubOptionIndex = foundSubOptionIndex || 0
  },
  methods: {
    getSubOptions() {
      return this.wordCloudColumns[0].subOptions
    },
    onSubOptionUpdate(newSubOption) {
      this.selectedSubOption = newSubOption
      const route = this.getRoute(this.selectedSubOption)
      if (!isEqual(this.$route.query, route.query)) {
        this.$router.push(route)
      }
    },
    getRoute(subOption) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
        },
      }
      if (subOption) {
        route.query[subOption.attributeName] = subOption.attributeValue
      }
      return route
    },
  },
}
</script>
